import React from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    TableBody,
    IconButton,
    CircularProgress,
} from '@mui/material';
import { Iconify } from '../Minimal/src/components/iconify';

export default function NotificationsTable({
    rows,
    listLoading,
    showActions = false,
    onOpenActionMenu,
}) {
    const colCount = showActions ? 6 : 5;
    return (
        <TableContainer
            sx={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                maxWidth: '100%',
            }}
        >
            <Table
                size="small"
                className="table-cell-border"
                // sx={{
                //     minWidth: { xs: 560, sm: 640 },
                //     '& .MuiTableCell-root': {
                //         fontSize: { xs: '0.75rem', sm: '0.875rem' },
                //     },
                // }}
            >
                <TableHead>
                    <TableRow className="table-cell-header">
                        <TableCell sx={{ width: '8%', whiteSpace: 'nowrap' }}>Sr No.</TableCell>
                        <TableCell sx={{ width: '19%', minWidth: 80 }}>Title</TableCell>
                        <TableCell sx={{ width: '45%', minWidth: 120 }}>Message</TableCell>
                        <TableCell sx={{ width: '19%', minWidth: 80 }}>Status</TableCell>
                        <TableCell sx={{ width: '21%', minWidth: 100, whiteSpace: 'nowrap' }}>Scheduled On</TableCell>
                        {showActions ? (
                            <TableCell align="center" sx={{ width: '9%', whiteSpace: 'nowrap' }}>
                                Actions
                            </TableCell>
                        ) : null}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {listLoading ? (
                        <TableRow>
                            <TableCell colSpan={colCount} align="center" sx={{ py: 6 }}>
                                <CircularProgress size={28} />
                            </TableCell>
                        </TableRow>
                    ) : rows.length > 0 ? (
                        rows.map((item, index) => (
                            <TableRow key={item.id} className="table-cell-style">
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{item.title}</TableCell>
                                <TableCell>{item.message}</TableCell>
                                <TableCell>{item.status}</TableCell>
                                <TableCell>{item.scheduledDate}</TableCell>
                                {showActions ? (
                                    <TableCell align="center">
                                        <IconButton
                                            size="small"
                                            onClick={(event) => onOpenActionMenu(event, item.id)}
                                            sx={{
                                                color: '#637381',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                },
                                            }}
                                        >
                                            <Iconify icon="eva:more-vertical-fill" width={18} height={18} />
                                        </IconButton>
                                    </TableCell>
                                ) : null}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={colCount} align="center" sx={{ py: 4, fontSize: '0.9rem' }}>
                                No notifications found
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
